var judulna = $('#judulna').val();
var array_bundle = [];
var array_idna = [];

$('.content-bundle').hide();
$('#content-1').show();
$(".bundlingnya").hide();
$(".bundlingnya2").hide();
$(".bundlingnya3").hide();

var id_pr_bd = $('#bundle1').val();
var img_aktif = $('#produk-bundling-' + id_pr_bd);
var variant_aktif = $('#variant-bundling-' + id_pr_bd);

var id_pr_bd2 = $('#bundle2').val();
var img_aktif2 = $('#produk-bundling2-' + id_pr_bd2);
var variant_aktif2 = $('#variant-bundling2-' + id_pr_bd2);

var id_pr_bd3 = $('#bundle3').val();
var img_aktif3 = $('#produk-bundling3-' + id_pr_bd3);
var variant_aktif3 = $('#variant-bundling3-' + id_pr_bd3);



img_aktif.show();
variant_aktif.show();

console.log(judulna);
img_aktif2.show();
variant_aktif2.show();

img_aktif3.show();
variant_aktif3.show();



var produk1 = '/products/' + id_pr_bd + '.js';
var produk2 = '/products/' + id_pr_bd2 + '.js';
var produk3 = '/products/' + id_pr_bd3 + '.js';


$('#bundle1').change(function(){
  img_aktif = $('#produk-bundling-' + $(this).val());
  variant_aktif = $('#variant-bundling-' + $(this).val());
  $(".bundlingnya").hide();
  img_aktif.show();
  variant_aktif.show();
  produk1 = '/products/' + $(this).val() + '.js';
});

$('#bundle2').change(function(){
  img_aktif2 = $('#produk-bundling2-' + $(this).val());
  variant_aktif2 = $('#variant-bundling2-' + $(this).val());
  $(".bundlingnya2").hide();
  img_aktif2.show();
  variant_aktif2.show();
  produk2 = '/products/' + $(this).val() + '.js';
});

$('#bundle3').change(function(){
  img_aktif3 = $('#produk-bundling3-' + $(this).val());
  variant_aktif3 = $('#variant-bundling3-' + $(this).val());
  $(".bundlingnya3").hide();
  img_aktif3.show();
  variant_aktif3.show();
  produk3 = '/products/' + $(this).val() + '.js';
});



$('#next1').click(function(){
  var produk_ = $('#bundle1').val();
  var variant_id = $("#variant-" + produk_).val();
  $('#tab-1').removeClass('active');
  $('#tab-2').addClass('active');
  $('#content-1').hide();
  $('#content-2').show();
  array_bundle.push({
    quantity: 1,
    properties: {
      'bundling name': judulna 
    },
    id: variant_id
  });

  console.log(array_bundle);
});

$('#back-next-1').click(function(){
  var produk_ = $('#bundle1').val();
  var variant_id = $("#variant-" + produk_).val();
  $('#tab-1').addClass('active');
  $('#tab-2').removeClass('active');
  $('#content-1').show();
  $('#content-2').hide();
  array_bundle.pop();
});


// button to review

$('#next2').click(function(){

  var produk_2 = $('#bundle2').val();
  var variant_id2 = $("#variant2-" + produk_2).val();
  $('#tab-2').removeClass('active');
  $('#tab-3').addClass('active');

  array_bundle.push({
    quantity: 1,
    properties: {
      'bundling name': judulna 
    },
    id: variant_id2
  });
  $('#content-2').hide();
  $('#content-3').show();

  jQuery.getJSON(produk1 , function(product1) {
    var sizena = [];
    for(var i = 0; i < product1.variants.length; i++){
      if (product1.variants[i].id == array_bundle[0].id ){
        sizena =  product1.variants[i].title
      }
    }
    console.log(sizena);    
    $('#product1').html('<img src="' + product1.featured_image + ' class="lazyload" /> <p>' +  product1.title + '</p>');
    array_idna.push({
      id: product1.id
    });
  });

  jQuery.getJSON(produk2 , function(product2) {
    var sizena = [];
    for(var i = 0; i < product2.variants.length; i++){
      if (product2.variants[i].id == array_bundle[1].id ){
        sizena =  product2.variants[i].title
      }
    }

    $('#product2').html('<img src="' + product2.featured_image + ' class="lazyload" /> <p>' +  product2.title + '</p>');
    array_idna.push({
      id: product2.id
    }); 
  });
  console.log(array_bundle);
});
// end button to review

// back to product
$('#back-next-2').click(function(){
  var produk_2 = $('#bundle2').val();
  var variant_id2 = $("#variant2-" + produk_2).val();
  $('#tab-2').addClass('active');
  $('#tab-3').removeClass('active');
  $('#content-2').show();
  $('#content-3').hide();
  array_bundle.pop(); 
});
// end back to product


$('#next3').click(function(){

  var produk_3 = $('#bundle3').val();
  var variant_id3 = $("#variant3-" + produk_3).val();
  $('#tab-3').removeClass('active');
  $('#tab-4').addClass('active');

  array_bundle.push({
    quantity: 1,
    properties: {
      'bundling name': judulna 
    },
    id: variant_id3
  });
  $('#content-2').hide();
  $('#content-3').hide();
  $('#content-4').show();

  jQuery.getJSON(produk1 , function(product1) {
    var sizena = [];
    for(var i = 0; i < product1.variants.length; i++){
      if (product1.variants[i].id == array_bundle[0].id ){
        sizena =  product1.variants[i].title
      }
    }
    console.log(sizena);    
    $('#product1').html('<img src="' + product1.featured_image + ' class="lazyload" /> <p class="text-center">' +  product1.title + '</p>');
    array_idna.push({
      id: product1.id
    });
  });

  jQuery.getJSON(produk2 , function(product2) {
    var sizena = [];
    for(var i = 0; i < product2.variants.length; i++){
      if (product2.variants[i].id == array_bundle[1].id ){
        sizena =  product2.variants[i].title
      }
    }

    $('#product2').html('<img src="' + product2.featured_image + ' class="lazyload" /> <p class="text-center">' +  product2.title + '</p>');
    array_idna.push({
      id: product2.id
    }); 
  });
  
  jQuery.getJSON(produk3 , function(product3) {
    var sizena = [];
    for(var i = 0; i < product3.variants.length; i++){
      if (product3.variants[i].id == array_bundle[1].id ){
        sizena =  product2.variants[i].title
      }
    }

    $('#product3').html('<img src="' + product3.featured_image + ' class="lazyload" /> <p class="text-center">' +  product3.title + '</p>');
    array_idna.push({
      id: product3.id
    }); 
  });
  console.log(array_bundle);
});
// end button to review

$('#back-next-3').click(function(){
  var produk_3 = $('#bundle3').val();
  var variant_id3 = $("#variant3-" + produk_3).val();
  $('#tab-3').addClass('active');
  $('#tab-4').removeClass('active');
  $('#content-3').show();
  $('#content-4').hide();
  array_bundle.pop(); 
});

$('#add-to-cart-bundling').click(function(){
  console.log(array_bundle)
  var cart = jQuery.post('/cart/add.js', {
    items: array_bundle,
  });
  console.log(array_idna)

  setTimeout(function(){
    window.location = '/cart';
  }, 2000);

});